/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_REGISTER_GST_STATE,
  CLOSE_BSB_NOTICE,
  RESET_TUGO_BANK_FIELDS,
  RESET_ADDRESS,
  FNOL_GET_PAYMENT_CODE_TYPES,
  FNOL_GET_PAYMENT_FORM_FIELDS,
  FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS,
  FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS,
  FNOL_SET_DYNAMIC_FIELD_VALUE,
  FNOL_RESET_DYNAMIC_FORM,
  FNOL_SET_SELECTED_CODE_TYPE,
  FNOL_VALIDATE_CODE_FIELD,
  FNOL_VALIDATE_TRANSIT_NUMBER_DYNAMIC,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormRegisterGstState() {
  return {
    type: RESET_REGISTER_GST_STATE,
  };
}

export function closeBSBNotice() {
  return {
    type: CLOSE_BSB_NOTICE,
  };
}

export function resetTugoBankFields() {
  return {
    type: RESET_TUGO_BANK_FIELDS,
  };
}

export function resetFormDataAddress() {
  return {
    type: RESET_ADDRESS,
  };
}

export function fnolGetPaymentCodeTypes(countryId) {
  return {
    type: FNOL_GET_PAYMENT_CODE_TYPES,
    countryId,
  };
}

export function fnolGetPaymentFormFields(countryId, codeTypeId) {
  return {
    type: FNOL_GET_PAYMENT_FORM_FIELDS,
    countryId,
    codeTypeId,
  };
}

export function fnolSetPaymentCodeTypes(data) {
  return {
    type: FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS,
    data,
  };
}

export function fnolSetPaymentFormFields(data) {
  return {
    type: FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS,
    data,
  };
}

export function fnolSetDynamicFieldValue(fieldName, value) {
  return {
    type: FNOL_SET_DYNAMIC_FIELD_VALUE,
    fieldName,
    value,
  };
}

export function fnolResetDynamicForm() {
  return {
    type: FNOL_RESET_DYNAMIC_FORM,
  };
}

export function fnolSetSelectedCodeType(codeTypeId) {
  return {
    type: FNOL_SET_SELECTED_CODE_TYPE,
    codeTypeId,
  };
}

export function fnolValidateCodeField(countryId, codeTypeId, code) {
  return {
    type: FNOL_VALIDATE_CODE_FIELD,
    countryId,
    codeTypeId,
    code,
  };
}

export function fnolValidateTransitNumberDynamic(code) {
  return {
    type: FNOL_VALIDATE_TRANSIT_NUMBER_DYNAMIC,
    code,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/actions.js